// EditableBooleanInline.tsx
import React, { useState, useEffect } from 'react';
import { Box, Switch, Typography, CircularProgress } from '@mui/material';

interface EditableBooleanInlineProps {
  value: boolean;
  onSave: (newValue: boolean) => Promise<void> | void;
  labelTrue?: string;
  labelFalse?: string;
  colorTrue?: string;
  colorFalse?: string;
  disabled?: boolean;
}

export const EditableBooleanInline: React.FC<EditableBooleanInlineProps> = ({
  value,
  onSave,
  labelTrue = 'Да',
  labelFalse = 'Нет',
  colorTrue = 'success.main',
  colorFalse = 'text.secondary',
  disabled = false,
}) => {
  const [currentValue, setCurrentValue] = useState<boolean>(value);
  const [loading, setLoading] = useState(false);

  // Синхронизация при внешнем изменении value (например, после refetch)
  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked;
    
    // Оптимистично обновляем локальный стейт
    setCurrentValue(newValue);
    setLoading(true);

    try {
      await onSave(newValue);
    } catch (error) {
      // При ошибке сохранения откатываем обратно
      setCurrentValue(value);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      component="span"
      sx={{
        // display: 'inline-flex',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        width: '100%',
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: currentValue ? colorTrue : colorFalse,
          fontWeight: 500,
          userSelect: 'none',
        }}
      >
        {currentValue ? labelTrue : labelFalse}
      </Typography>

{/* сначала спинер иначе прыгает */}
      {loading && <CircularProgress size={14} sx={{ color: 'text.secondary', visibility: loading ? 'visible' : 'hidden', }} />}

      <Switch
        size="small"
        checked={currentValue}
        onChange={handleChange}
        disabled={disabled || loading}
      />

    </Box>
  );
};